"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserArea = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tooltip = require("b2b-components/core/components/Tooltip");
var _Button = require("b2b-components/theme/components/Button");
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _CartButton = require("b2b-components/theme/components/CartButton");
var _Dashboard = require("b2b-components/theme/components/Dashboard");
var _Dropdown = require("b2b-components/theme/components/Dropdown");
var _Icon = require("b2b-components/theme/components/Icon");
var _device = require("b2b-components/utils/device");
var _classnames = _interopRequireDefault(require("classnames"));
require("./UserArea.scss");
var UserArea = function UserArea(_ref) {
  var cartProductCount = _ref.cartProductCount,
    cartValue = _ref.cartValue,
    deviceType = _ref.deviceType,
    hasKanban = _ref.hasKanban,
    hasExpressOrder = _ref.hasExpressOrder,
    hasMyAccount = _ref.hasMyAccount,
    hasWishlists = _ref.hasWishlists,
    isLoggedIn = _ref.isLoggedIn,
    onCartClick = _ref.onCartClick,
    onExpressOrderClick = _ref.onExpressOrderClick,
    onLogin = _ref.onLogin,
    onLogout = _ref.onLogout,
    onMyAccountClick = _ref.onMyAccountClick,
    onMyAccountLinkClick = _ref.onMyAccountLinkClick,
    onWishlistsClick = _ref.onWishlistsClick,
    onKanbanClick = _ref.onKanbanClick,
    isRegisterEnabled = _ref.isRegisterEnabled,
    onRegister = _ref.onRegister,
    text = _ref.text,
    myAccountDashboardLinks = _ref.myAccountDashboardLinks,
    hasOnlyCoreAssortment = _ref.hasOnlyCoreAssortment,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {
      loginButton: {},
      logoutButton: {},
      cartButton: {}
    } : _ref$dataAttributes,
    className = _ref.className;
  var rootClassName = (0, _classnames["default"])('cds-UserArea', {
    'cds-UserArea--Mobile': !(0, _device.isTablet)(deviceType) && (0, _device.isMobile)(deviceType)
  }, className);
  var RegisterButton = function RegisterButton() {
    return /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      size: _Button.BUTTON_SIZE.small,
      styleType: _Button.BUTTON_STYLE_TYPE.ghost,
      onClick: function onClick() {
        return onRegister === null || onRegister === void 0 ? void 0 : onRegister();
      }
    }, text.register);
  };
  var LoginButton = function LoginButton() {
    return /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      size: _Button.BUTTON_SIZE.small,
      onClick: function onClick() {
        return onLogin === null || onLogin === void 0 ? void 0 : onLogin();
      },
      dataAttributes: dataAttributes.loginButton
    }, text.login);
  };
  var UnloggedButtons = function UnloggedButtons() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isRegisterEnabled && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(RegisterButton, null)), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(LoginButton, null)));
  };
  switch (true) {
    case (0, _device.isDesktop)(deviceType):
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: rootClassName
      }, isLoggedIn ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasExpressOrder && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Dropdown.Dropdown.Toggler, {
        className: "cds-UserArea-MyAccountButton cds-UserArea-MyAccountButton--ExpressOrder",
        icon: _Dropdown.Dropdown.Toggler.config.iconName.expressOrder,
        label: text.expressOrder,
        onClick: function onClick() {
          return onExpressOrderClick();
        },
        withArrow: false
      })), hasWishlists && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Dropdown.Dropdown.Toggler, {
        className: "cds-UserArea-MyAccountButton",
        icon: _Dropdown.Dropdown.Toggler.config.iconName.wishlist,
        label: text.wishlists,
        onClick: function onClick() {
          return onWishlistsClick();
        },
        withArrow: false
      })), hasMyAccount && /*#__PURE__*/_react["default"].createElement("li", {
        className: "cds-UserArea-Li-MyAccount"
      }, /*#__PURE__*/_react["default"].createElement(_Dropdown.Dropdown, {
        content: /*#__PURE__*/_react["default"].createElement(_Dashboard.Dashboard, {
          groups: myAccountDashboardLinks,
          onLinkClick: onMyAccountLinkClick
        }),
        isHoverable: true,
        togglerProps: {
          icon: _Dropdown.Dropdown.Toggler.config.iconName.account,
          label: text.myAccount,
          onClick: onMyAccountClick,
          withArrow: false,
          className: 'cds-UserArea-MyAccountButton'
        }
      }), hasOnlyCoreAssortment && /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
        triggerClassName: "cds-UserArea-Icon-TooltipTrigger",
        content: text.coreAssortmentOnly
      }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
        name: _Icon.ICON_NAME.coreAssortment,
        size: _Icon.ICON_SIZE.small
      }))), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
        size: _Button.BUTTON_SIZE.small,
        styleType: _Button.BUTTON_STYLE_TYPE.light,
        className: "cds-UserArea-Button--Logout",
        onClick: function onClick() {
          return onLogout === null || onLogout === void 0 ? void 0 : onLogout();
        },
        dataAttributes: dataAttributes.logoutButton
      }, text.logout)), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_CartButton.CartButton, {
        onClick: function onClick() {
          return onCartClick();
        },
        value: cartValue,
        productCount: cartProductCount,
        dataAttributes: dataAttributes.cartButton
      }))) : /*#__PURE__*/_react["default"].createElement(UnloggedButtons, null));
    case (0, _device.isTablet)(deviceType):
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: rootClassName
      }, isLoggedIn ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasKanban && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Dropdown.Dropdown.Toggler, {
        className: "cds-UserArea-MyAccountButton",
        icon: _Icon.ICON_NAME.expressOrder,
        label: text.kanbanOrder,
        onClick: onKanbanClick,
        withArrow: false
      })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_Dropdown.Dropdown.Toggler, {
        className: "cds-UserArea-MyAccountButton",
        icon: _Dropdown.Dropdown.Toggler.config.iconName.account,
        label: text.myAccount,
        onClick: function onClick() {
          return onMyAccountClick();
        },
        withArrow: false
      })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_CartButton.CartButton, {
        onClick: function onClick() {
          return onCartClick();
        },
        value: cartValue,
        productCount: cartProductCount,
        dataAttributes: dataAttributes.cartButton
      }))) : /*#__PURE__*/_react["default"].createElement(UnloggedButtons, null));
    case (0, _device.isMobile)(deviceType):
    default:
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: rootClassName
      }, isLoggedIn ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasKanban && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_ButtonIcon.ButtonIcon, {
        className: "cds-UserArea-MyAccountButton",
        icon: _Icon.ICON_NAME.expressOrder,
        onClick: onKanbanClick,
        size: _ButtonIcon.BUTTON_ICON_SIZE.small,
        styleType: _Button.BUTTON_STYLE_TYPE.secondary
      })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_ButtonIcon.ButtonIcon, {
        className: "cds-UserArea-MyAccountButton",
        icon: _ButtonIcon.BUTTON_ICON_ICON_NAME.account,
        onClick: function onClick() {
          return onMyAccountClick();
        },
        size: _ButtonIcon.BUTTON_ICON_SIZE.small
      })), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_CartButton.CartButton, {
        onClick: function onClick() {
          return onCartClick();
        },
        productCount: cartProductCount,
        styleType: _CartButton.CART_BUTTON_STYLE_TYPE.minified,
        dataAttributes: dataAttributes.cartButton
      }))) : /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(LoginButton, null)));
  }
};
exports.UserArea = UserArea;